import { render, staticRenderFns } from "./TableEventProduct.vue?vue&type=template&id=4d3f58d2&scoped=true&"
import script from "./TableEventProduct.vue?vue&type=script&lang=js&"
export * from "./TableEventProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3f58d2",
  null
  
)

export default component.exports